export default __webpack_public_path__ + "static/media/flashlight-flat.424e34c5.svg";